/* eslint-disable no-param-reassign */

/**
 * Fix common misspellings in hyperlinks which may occur in data string.
 * Hyperlinks found in solicitations appear to come from the same source
 * across all the various solicitations and that several of them are
 * misspelled in such a way as to make the hyperlinks useless. 
 * However, since they are consistently misspelled, I correct the 
 * misspellings (mostly cases of a space being in the middle of the
 * hyperlink).
 * @param data - String potentially containing hyperlinks.
 * @returns - Corrected string.
 */
const fixHyperlinks = data => {
  data = data.replaceAll('.d la.', '.dla.');
  data = data.replaceAll('.dl a.', '.dla.');
  data = data.replaceAll('.a spx', '.a/spx');
  data = data.replaceAll('-Valid ation/', '-Validation/');
  data = data.replaceAll('.mil /', '.mil/');
  return data;
}

export default fixHyperlinks;


// WEBPACK FOOTER //
// ./src/components/grids/ItemDescInfoGrid/fixHyperlilnks.jsx